module.exports = __webpack_public_path__ + "img/1.b95a3f9a.svg";